
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.5.041h-7a1.5 1.5 0 000 3H3v12.918a.992.992 0 00.052.316l1 3a1 1 0 001.9 0l1-3A1 1 0 007 15.959V3.041h1.5a1.5 1.5 0 000-3zM6 15.959l-1 3-1-3V3.041h2zM8.5 2.041h-7a.5.5 0 010-1h7a.5.5 0 010 1zM23.237 8.2l-6.1-3.438a1.5 1.5 0 00-1.473 2.613l1.306.737-6.344 11.252a1.041 1.041 0 00-.11.3l-.6 3.1a1 1 0 001.652.932l2.347-2.124a1.011 1.011 0 00.2-.249l6.345-11.252 1.307.736a1.489 1.489 0 00.735.2 1.521 1.521 0 00.4-.056 1.5 1.5 0 00.335-2.751zm-10 12.639L10.9 22.96l.6-3.106L17.843 8.6l1.742.982zm9.7-11.087a.5.5 0 01-.682.189l-1.742-.982L17.9 7.485 16.157 6.5a.5.5 0 11.491-.871l6.1 3.438a.5.5 0 01.188.684z"}})])
          )
        }
      }
    